import React, {
  useEffect,
  useState,
} from "react";

import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { IoIosGlobe } from "react-icons/io";

import { BsBriefcase } from "react-icons/bs";

import { SlLocationPin } from "react-icons/sl";

import { FaCircleArrowLeft } from "react-icons/fa6";

import ApiService from "../../../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

/* =========================================================
   SECTION COMPONENT
========================================================= */

const Section = ({
  title,
  children,
}) => (

  <div
    style={{
      marginBottom: "20px",
    }}
  >

    <h4
      style={{
        color: "#0d1b4c",
        marginBottom: "10px",
      }}
    >
      {title}
    </h4>

    {children}

  </div>
);

/* =========================================================
   JOB VIEW
========================================================= */

const JobView = () => {

  const { jobId } =
    useParams();

  const navigate =
    useNavigate();

  const location =
    useLocation();

  /* =========================================================
      STATES
  ========================================================= */

  const [job, setJob] =
    useState(
      location.state?.job || null
    );

  const [loading, setLoading] =
    useState(false);

  /* =========================================================
      LOAD JOB DETAILS API
  ========================================================= */

  useEffect(() => {

    /* =========================================
        IF STATE JOB EXISTS
    ========================================= */

    if (location.state?.job) {

      setJob(
        location.state.job
      );

      return;
    }

    /* =========================================
        OTHERWISE FETCH API
    ========================================= */

    fetchJobDetails();

  }, [jobId]);

  /* =========================================================
      FETCH JOB DETAILS
  ========================================================= */

  const fetchJobDetails =
    async () => {

      try {

        setLoading(true);

        const response =
          await JobAPI.studentPreviewJob(
            jobId
          );

        console.log(
          "JOB DETAILS RESPONSE :",
          response
        );

        console.log(
          "JOB DETAILS DATA :",
          response?.data
        );

        const apiJob =

          response?.data?.job ||

          response?.data?.data ||

          response?.data ||

          null;

        setJob(apiJob);

      } catch (error) {

        console.log(
          "JOB DETAILS ERROR :",
          error
        );

        console.log(
          "JOB DETAILS ERROR RESPONSE :",
          error?.response?.data
        );

        setJob(null);

      } finally {

        setLoading(false);
      }
    };

  /* =========================================================
      LOADING
  ========================================================= */

  if (loading) {

    return (

      <div className="text-center mt-5">

        <h4>
          Loading Job Details...
        </h4>

      </div>
    );
  }

  /* =========================================================
      NO JOB
  ========================================================= */

  if (!job) {

    return (

      <div className="text-center mt-5">

        <h4>
          Job not found
        </h4>

      </div>
    );
  }

  /* =========================================================
      HELPERS
  ========================================================= */

  const skillsArray =

    typeof job.required_skills ===
    "string"

      ? job.required_skills
          .split(",")

      : Array.isArray(
          job.required_skills
        )

      ? job.required_skills

      : [];

  const perksArray =

    typeof job.perks_benefits ===
    "string"

      ? job.perks_benefits
          .split(",")

      : Array.isArray(
          job.perks_benefits
        )

      ? job.perks_benefits

      : [];

  /* =========================================================
      UI
  ========================================================= */

  return (

    <div
      style={{
        maxWidth: "900px",
        margin: "30px auto",
        border: "1px solid #ddd",
        borderRadius: "10px",
        overflow: "hidden",
        background: "#fff",
        boxShadow:
          "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={{
          background: "#0d1b4c",
          color: "#fff",
          padding: "20px",
        }}
      >

        <FaCircleArrowLeft
          style={{
            fontSize: "28px",
            cursor: "pointer",
          }}
          onClick={() =>
            navigate(-1)
          }
        />

        <div className="text-center">

          <h2 className="mt-3">

            {job.title}

          </h2>

          <h5>

            {job.company_name}

          </h5>

          <p className="mt-3">

            <IoIosGlobe />

            {" "}

            {job.department}

            {"  |  "}

            <BsBriefcase />

            {" "}

            {job.min_experience}

            {" - "}

            {job.max_experience}

            {" "}
            Years

            {"  |  "}

            <SlLocationPin />

            {" "}

            {job.location}

          </p>

        </div>

      </div>

      {/* =====================================================
          BODY
      ===================================================== */}

      <div
        style={{
          padding: "25px",
        }}
      >

        {/* ROLE */}

        <Section title="Roles & Responsibilities">

          <p>

            {
              job.roles_responsibilities
            }

          </p>

        </Section>

        {/* SKILLS */}

        <Section title="Required Skills">

          <ul>

            {skillsArray.length >
            0 ? (

              skillsArray.map(
                (
                  skill,
                  index
                ) => (

                  <li
                    key={index}
                  >

                    {skill}

                  </li>
                )
              )

            ) : (

              <li>
                No Skills
              </li>
            )}

          </ul>

        </Section>

        {/* QUALIFICATION */}

        <Section title="Qualification Required">

          <p>

            {
              job.qualification_required
            }

          </p>

        </Section>

        {/* SALARY */}

        <Section title="Salary Range">

          <p>

            ₹
            {job.min_salary}

            {" - "}

            ₹
            {job.max_salary}

            {" "}
            LPA

          </p>

        </Section>

        {/* PERKS */}

        <Section title="Perks & Benefits">

          <ul>

            {perksArray.length >
            0 ? (

              perksArray.map(
                (
                  perk,
                  index
                ) => (

                  <li
                    key={index}
                  >

                    {perk}

                  </li>
                )
              )

            ) : (

              <li>
                No Benefits
              </li>
            )}

          </ul>

        </Section>

        {/* LOCATION */}

        <Section title="Job Location">

          <p>

            {job.location}

          </p>

        </Section>

        {/* LOCALITY */}

        <Section title="Job Locality">

          <p>

            {job.locality}

          </p>

        </Section>

        {/* OPENINGS */}

        <Section title="Number of Openings">

          <p>

            {job.openings}

          </p>

        </Section>

        {/* WORK MODE */}

        <Section title="Work Mode">

          <p>

            {job.work_mode}

          </p>

        </Section>

        {/* DEADLINE */}

        <Section title="Application Deadline">

          <p>

            {
              job.application_deadline
            }

          </p>

        </Section>

        {/* WHATSAPP */}

        <Section title="Whatsapp Number">

          <p>

            {
              job.whatsapp_number
            }

          </p>

        </Section>

        {/* STATUS */}

        <Section title="Job Status">

          <p>

            {job.status}

          </p>

        </Section>

        {/* APPLY BUTTON */}

        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
          }}
        >

          <button
            className="livejobs-btn"
            style={{
              padding:
                "12px 40px",
            }}
            onClick={() =>

              navigate(
                `/Student/LiveJobs/${jobId}`,
                {
                  state: {
                    job,
                  },
                }
              )

            }
          >

            Apply

          </button>

        </div>

      </div>

    </div>
  );
};

export default JobView;